<template lang="pug">
  y-dialog(v-if="showModal" v-model="showModal" scrollable max-width='600px' persistent)
    v-card
      v-card-title.px-4
        div.h6.basic800--text {{ $t('manage_shipping_zones') }}
      v-divider.basic300
      v-card-text.pt-4.px-0.pb-0
        div.c1.primary400--text.mx-4 {{ $t('enable_disable_shipping_zones') }}
        div.mt-4
          template(v-for="(zone, idx) in zones")
            div.d-flex.align-center.py-4.pr-1.pl-4(:key="zone.id")
              div.s1.basic800--text {{ zone.name }}
              v-spacer
              div
                y-switch.mb-n3.mx-0.pa-0(v-model="zone.enabled" @change="updateExcluded(zone)")
            v-divider.basic300
          //- v-simple-table
            tbody
              tr(v-for="(zone, idx) in zones" :key="zone.id")
                td
                  div.py-1
                    p.my-auto.text-body-2 {{ zone.name }}
                td(align="end")
                  div(style="width: 100%" align="right")
                    //- NOTE: zone.enabled here correspond to current form only
                    v-switch.my-auto.mx-0.pa-0(v-model="zone.enabled" hide-details @click="updateExcluded(zone)" style="width: 35px")
      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text {{ $t('cancel') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click='saveExcluded()' )
          .button-AA-small.basic100--text {{ $t('save') }}
</template>

<script>
export default {
  name: 'EditFormZonesDialog',
  props: ['open', 'company', 'form', 'szones', 'excludedZones'],
  data: (v) => ({
    zones: v.szones || [],
    exZones: [] // Working array
  }),
  mounted () {
    this.exZones = [...this.excludedZones]
    this.zones.forEach(zone => {
      zone.enabled = this.exZones.indexOf(zone.id) === -1
    })
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    updateExcluded(zone) {
      let index = this.exZones.indexOf(zone.id)
      if (zone.enabled && index !== -1) {
        this.exZones.splice(index, 1);
      } else if (!zone.enabled && index === -1) {
        this.exZones.push(zone.id)
      }
    },
    saveExcluded () {
      let data = {'excluded_zones': this.exZones}
      this.$axios.patch(`/forms/${this.form.id}`, data).then(() => {
        this.$emit('update:excludedZones', this.exZones)
      }).catch(() => {}).finally(()=>{
        this.showModal = false
      })
    }
  }
}
</script>

<style scoped>
.message {
  white-space: pre-wrap;
}
</style>

<i18n>
{
  "en": {
    "enable_disable_shipping_zones": "Enable / Disable shipping zones for this form."
  },
  "id": {
    "enable_disable_shipping_zones": "Aktif / Nonaktifkan Zona pengiriman untuk form ini."
  }
}
</i18n>